<template>
    <span>
        <b-button
            v-if="allowLogin"
            class="align-baseline mr-1"
            title="Login"
            variant="default"
            v-b-modal="loginModalID"
        >
            <font-awesome-icon :icon="['fas', 'circle-user']"></font-awesome-icon>
        </b-button>
        <b-button
            v-if="allowLogin"
            class="align-baseline mr-1"
            title="App Login As..."
            variant="default"
            v-b-modal="loginModalMobileID"
        >
            <font-awesome-icon :icon="['fas', 'mobile-screen-button']" />
        </b-button>
        <b-button class="align-baseline mr-1" title="Edit" variant="default" @click="handleEditClick">
            <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
        </b-button>
        <b-button
            v-if="allowDelete"
            class="align-baseline mr-1"
            title="Delete"
            variant="default"
            v-b-modal="deleteModalID"
        >
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal :id="loginModalID" title="Login" @shown="onModalShown" @ok="loginTeamMember"
            >Are you sure you want to log in as {{ teamMemberEmail }}?</modal
        >
        <modal :id="loginModalMobileID" title="Login on Mobile App" @shown="onModalShown" @ok="loginMobileTeamMember"
            >Are you sure you want to log in as {{ teamMemberEmail }} on the mobile app?</modal
        >
        <modal :id="deleteModalID" title="Delete Team Member" @shown="onModalShown" @ok="deleteTeamMember"
            >Are you sure you want to delete {{ teamMemberEmail }}?</modal
        >
    </span>
</template>

<script>
    import API from '../../../api';
    import Modal from '../../generic/modal/modal.vue';
    import { TEAM_MEMBER_BY_ID_ENDPOINT } from '../../../endpoints';

    export default {
        components: {
            Modal,
        },
        data() {
            return {
                teamMemberID: 0,
                loginModalID: '',
                loginModalMobileID: '',
                deleteModalID: '',
                teamMemberEmail: '',
            };
        },
        computed: {
            allowLogin() {
                return this.params.data.is_active && this.params.data.allow_login;
            },
            allowDelete() {
                return this.params.data.allow_delete;
            },
        },
        created() {
            this.teamMemberID = this.params.data.id;
            this.teamMemberEmail = this.params.data.email;
            this.loginModalID = `modal-login-team-member-${this.teamMemberID}`;
            this.loginModalMobileID = `modal-login-mobile-team-member-${this.teamMemberID}`;
            this.deleteModalID = `modal-delete-team-member-${this.teamMemberID}`;
        },
        methods: {
            onModalShown() {
                this.params.api.clearFocusedCell();
            },
            handleEditClick() {
                this.$router.push(`/app/team-member/${this.teamMemberID}/edit/`);
            },
            loginTeamMember() {
                window.location = `/system/team-members/login-as-team-member/${this.teamMemberID}/`;
            },
            loginMobileTeamMember() {
                window.location = `/system/team-members/login-as-team-member/${this.teamMemberID}?redirect_to_mobile_app=true`;
            },
            async deleteTeamMember() {
                try {
                    await API.delete(TEAM_MEMBER_BY_ID_ENDPOINT(this.teamMemberID));
                } catch (error) {
                    this.errorToast({ text: `Could not delete team member.` });
                    return;
                }
                this.params.api.refreshServerSide();
            },
        },
    };
</script>
